import api from "@/lib/api";

/**
 * Thumbs up and down, cached so every button in the app agrees without each
 * one asking the API. Mirrors the shape of lib/likes.js.
 */
let cache = null;

export async function loadVotes() {
  try {
    const { data } = await api.get("/music/votes");
    cache = new Map();
    for (const id of data.up || []) cache.set(id, 1);
    for (const id of data.down || []) cache.set(id, -1);
  } catch (e) {
    cache = new Map();
  }
  window.dispatchEvent(new Event("votes-changed"));
  return cache;
}

export function voteOf(id) {
  return cache && cache.has(id) ? cache.get(id) : 0;
}

/** Pressing the active side clears the vote, so it works as a toggle. */
export async function setVote(id, vote) {
  if (!cache) await loadVotes();
  const next = voteOf(id) === vote ? 0 : vote;

  if (next === 0) cache.delete(id);
  else cache.set(id, next);
  window.dispatchEvent(new Event("votes-changed"));

  api.post("/music/votes", { track_id: id, vote: next }).catch(() => {});
  return next;
}
